/**
 * @generated SignedSource<<d3e5ee22347f44cd2151786d5e53c7e9>>
 * @relayHash de7718c29bbf9250b6553ea1f486b38b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c90e5fe5d1f4ba9b0d856e0b9447e97c31cd8e698a602c0314da090fdf45906

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
};
export type GoalPanelQuery$data = {
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly townsquare: {
    readonly goal: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"GoalFollowers" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatus" | "GoalTags" | "GoalTargetDate" | "GoalType" | "ParentGoal" | "SubGoals">;
    } | null | undefined;
  } | null | undefined;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v5/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v10 = [
  (v8/*: any*/)
],
v11 = [
  {
    "kind": "ScalarField",
    "name": "url"
  },
  {
    "concreteType": "TownsquareStatus",
    "kind": "LinkedField",
    "name": "status",
    "plural": false,
    "selections": (v10/*: any*/)
  },
  (v2/*: any*/),
  {
    "concreteType": "TownsquareGoalType",
    "kind": "LinkedField",
    "name": "goalType",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v1/*: any*/)
    ]
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "GoalPanelTitleField"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalStatus"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalType"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalOwner"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTargetDate"
              },
              {
                "kind": "FragmentSpread",
                "name": "ParentGoal"
              },
              {
                "kind": "FragmentSpread",
                "name": "SubGoals"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTags"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalFollowers"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalStartDate"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      },
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "concreteType": "TownsquareGoalIcon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "appearance"
                  }
                ]
              },
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "score"
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "TownsquareGoalTypeCustomName"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "defaultValue"
                          }
                        ],
                        "type": "TownsquareLocalizationField"
                      }
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTargetDateRange",
                    "kind": "LinkedField",
                    "name": "dateRange",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "start"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "end"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "parentGoal",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareUserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v1/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              {
                "kind": "ScalarField",
                "name": "creationDate"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6c90e5fe5d1f4ba9b0d856e0b9447e97c31cd8e698a602c0314da090fdf45906",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e4a8704aa68d35539e01eb83a60ad2b7";

export default node;
